import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

import { Fields } from '~/components/partials/GuestPatientForm/types';
import { newPatientDrawerState } from '~/state/patient/atoms';

export const useDefaultValues = () => {
  const { inputValue, qrCodePatient } = useAtomValue(newPatientDrawerState);

  const defaultValues: Fields = useMemo(() => {
    if (qrCodePatient) {
      return {
        ...qrCodePatient,
        mobilePhone: inputValue?.mobilePhone || '',
      };
    }

    if (inputValue) {
      return inputValue;
    }

    return {
      familyName: '',
      givenName: '',
      phoneticFamilyName: '',
      phoneticGivenName: '',
      birthDate: '',
      sex: 'male',
      mobilePhone: '',
    };
  }, [inputValue, qrCodePatient]);

  return defaultValues;
};
